// @flow
import React from "react";
import { connect } from "react-redux";
import MainContent from "../MainContent/MainContent";
import Navigation from "../../components/Navigation/Navigation";
import { LoadingScreen, Footer } from "@nike/ruxac";
import { loadData, cbdError } from "../../data/modules/ui";
import { checkForToken, login } from "../../loginHelpers";
import Error from "../Errors/Errors";
import isEmpty from "lodash.isempty";
import {cbdIdVersion} from '../../utils/downloadLogic';

type Props = {
  ui: Object,
  loadData: Function
};

class CBDView extends React.Component<Props> {
  componentDidMount() {
    const jwt = checkForToken();
    //first set the queryString for the cbd
    const url = window.location.href;
    const cbdIdVerString = url ? url.split("?")[1] : window.location.search.slice(1);

    if (cbdIdVerString && !cbdIdVersion.cbdString) {
      cbdIdVersion.cbdString = cbdIdVerString;
    }
      if (cbdIdVerString){
      if (!jwt || !jwt.accessToken) {
        localStorage.setItem("cbdIdVer", cbdIdVerString);
        //redirect to SSO if detects query string has been entered and no jwt present
        login();
      } else {
        //load data from API if jwt present
        this.props.loadData(jwt.accessToken);
      }
    } else if (jwt && jwt.accessToken) {
      //load data from API if jwt present
      this.props.loadData(jwt.accessToken);
    } else {
      this.props.cbdError();
    }
  }
  render() {
    const fetching = this.props.ui.isFetchingReferenceData;
    const failedLoad = !this.props.ui.data || isEmpty(this.props.ui.data);
    const error = this.props.ui.data && this.props.ui.data.code;
    return (
      <div>
        {fetching ? (
          <LoadingScreen isLoading={true} loadingMessage="Loading CBD" />
        ) : failedLoad || error ? (
          <Error
            errorCode={this.props.ui.data && this.props.ui.data.code ? this.props.ui.data.code : ""}
          />
        ) : (
          <div>
            <Navigation />
            <MainContent ui={this.props.ui} />
            <Footer />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ui: state.ui
});

const mapDispatchToProps = { loadData, cbdError };
export default connect(mapStateToProps, mapDispatchToProps)(CBDView);



// WEBPACK FOOTER //
// ./src/components/CBDView/CBDView.js